import { Box, useTheme } from "@mui/material";
import { useMemo, useState } from "react";
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
import PopoverModal from "../../../../theme/Modal/PopoverModal";
import { useTranslation } from "react-i18next";

export const ChartLegendPopover = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'legend-popover' : undefined;

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box
                onClick={handlePopoverOpen}
                sx={{
                    flex: 1,
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 1,
                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    height: 24,
                    whiteSpace: "nowrap",
                    borderRadius: 3,
                    fontWeight: 500,
                    fontFamily: "Roboto, sans-serif",
                    color: colors.txt["primary"],
                    cursor: "pointer",
                    "&:hover" : {
                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200]
                    }
                }}
            >
                +{props.hiddenCount} {t("more")}
            </Box>

            <PopoverModal
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                triangle={{ position: "center", color: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0] }}
            >
                <Box
                    sx={{
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        padding: 2,
                        borderRadius: 4,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        minWidth:300,
                        maxWidth: 300,
                        maxHeight: 400,
                        overflow: "auto",
                        "@media screen and (max-width: 47.9375em)" : {
                            maxWidth:"unset",
                            width:1,
                        }
                    }}
                >
                    {props.values?.map((series, index) => {
                        const colorIndex = index % props.staticColors.length;
                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: "50%",
                                        backgroundColor: props.staticColors[colorIndex],
                                        flexShrink: 0,
                                    }}
                                />
                                <Text>
                                    {t(series.name) ?? t(series.description)}
                                </Text>
                                <Text bold sx={{ml:"auto"}}>
                                    {props.seriesTotals?.[index]?.toLocaleString() ?? 0}
                                </Text>
                            </Box>
                        );
                    })}
                </Box>
            </PopoverModal>
        </>
    );
};
